var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","color":_vm.item.is_active ? 'green accent-3' : 'red accent-2'},on:{"click":_vm.updateActivation}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-circle")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.item.is_active ? "Click to deactivate" : "Click to activate"))])])}
var staticRenderFns = []

export { render, staticRenderFns }